import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Modal } from 'react-bootstrap'

import buttonStyle from 'Styles/button.css'
import style from './coachSignupModal.css'

export default class CoachSignupModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      phone: ''
    }

    this.phonePattern = /\d{3}-\d{3}-\d{4}/
  }

  onPhoneChange (event) {
    const old = this.state.phone
    let data = event.target.value.replace(/[^\d-]/g, '')
    // prevent double dashes
    data = data.replace(/-+/g, '-')
    data = old.length === 2 && data.length === 3 ? data + '-' : data
    data = old.length === 6 && data.length === 7 ? data + '-' : data
    data = data.length > 12 ? data.substring(0, 12) : data
    this.setState({ phone: data })
  }

  onSubmit () {
    this.props.onSubmit(this.state.phone)
  }

  onCancel () {
    this.props.onSubmit()
  }

  renderSignup () {
    const disabled = this.state.phone.length !== 12 ||
      !this.phonePattern.test(this.state.phone)

    return (
      <Modal show={true}>
        <div className={style.containerModal}>

          <Modal.Header className={style.title}>
            <Modal.Title className={style.title}>Don't forget what you've learned!</Modal.Title>
          </Modal.Header>

          <Modal.Body className={style.text}>
            Enter your mobile phone number, and get follow-up questions from LearningCurve COACH.

            <p className={style.prompt}>
              Mobile phone number:
            </p>
            <input
              className={style.phoneInput}
              value={this.state.phone}
              onChange={this.onPhoneChange.bind(this)}
            />
          </Modal.Body>

          <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
            <div className={style.buttonContainer}>
              <button
                className={classnames(buttonStyle.rectangle, 'btn-cdl-main', disabled
                  ? style.disabledButton
                  : style.acceptButton)}
                onClick={this.onSubmit.bind(this)}
                disabled={disabled}
              >
              Text me questions!
              </button>

              <button
                className={classnames(buttonStyle.rectangle, style.cancelButton, 'btn-cdl-secondary')}
                onClick={this.onCancel.bind(this)}
              >
              Cancel
              </button>
            </div>
          </Modal.Footer>

        </div>
      </Modal>
    )
  }

  renderSignupComplete () {
    return (
      <Modal show={true}>
        <div className={style.containerModal}>

          <Modal.Header className={style.title}>
            <Modal.Title className={style.title}>Thanks!</Modal.Title>
          </Modal.Header>

          <Modal.Body className={style.text}>
            You will begin receiving LearningCurve questions via text message<br />
            at <b>{this.state.phone}</b> to help you retain your learning.
          </Modal.Body>

          <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
            <div className={style.buttonContainer}>
              <button
                className={classnames(buttonStyle.rectangle, style.okButton)}
                onClick={this.props.onCancel}
              >
                OK
              </button>
            </div>
          </Modal.Footer>

        </div>
      </Modal>
    )
  }

  render () {
    return this.props.coach.signUpComplete
      ? this.renderSignupComplete()
      : this.renderSignup()
  }
}
CoachSignupModal.propTypes = {
  coach: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}
